import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { getECMode, getEditMode, getFormValid } from '../../store/selectors'

import debounce from 'lodash/debounce'

import { GlobalAlert } from '../../../../components'
import { AboutModal, JobStatus } from '../../components'
import { MaintenanceMode, Workspace, TopNavigation, Responsive } from '../../../../containers'
import PrintView from '../PrintView'
import DesktopView from '../DesktopView'
import TabletView from '../TabletView'
import MobileView from '../MobileView'

import { APP_CONFIG } from '../../common/constants'

import bpAdmin from '../../../../../assets/data/bpAdmin.json'

const PageView = () => {
  const isEditMode = useSelector(getEditMode)
  const isValid = useSelector(getFormValid)
  const isECMode = useSelector(getECMode)

  const setMediaClass = (width) => {
    let mediaClass = null

    if (width < 768) {
      mediaClass = '-media-xs'
    } else if (width < 992) {
      mediaClass = '-media-sm'
    } else if (width < 1600) {
      mediaClass = '-media-md'
    } else {
      mediaClass = '-media-lg'
    }
    document.documentElement.classList.remove('-media-xs', '-media-sm', '-media-md', '-media-lg')
    document.documentElement.classList.add(mediaClass)
  }

  useEffect(() => {
    document.documentElement.classList.add(APP_CONFIG.productThemeClasses)
    setMediaClass(window.innerWidth)

    const debouncedHandleResize = debounce(() => setMediaClass(window.innerWidth), 500)

    window.addEventListener('resize', debouncedHandleResize)

    return () => {
      window.removeEventListener('resize', debouncedHandleResize)
    }
  }, [])

  return (
    <React.Fragment>
      <TopNavigation
        appConfig={APP_CONFIG}
        companyLogoProps={{
          disabled: isECMode,
        }}
        downloadProps={{
          disabled: isEditMode || !isValid,
        }}
        about={AboutModal}
        print={PrintView}
      />
      {bpAdmin && bpAdmin.applications[APP_CONFIG.appCode] === 'off' ? (
        <MaintenanceMode appCode={APP_CONFIG.appCode} appName={APP_CONFIG.appName} />
      ) : (
        <Workspace>
          <GlobalAlert />
          <JobStatus />
          <Responsive.Desktop>
            <DesktopView />
          </Responsive.Desktop>
          <Responsive.Tablet>
            <TabletView />
          </Responsive.Tablet>
          <Responsive.Mobile>
            <MobileView />
          </Responsive.Mobile>
        </Workspace>
      )}
    </React.Fragment>
  )
}

export default PageView
